import React, { useState } from "react";
import useMyStore from "../../../contexts/projectContext";

import IssueResolution from "./IssueResolution";
import AccountIdentity from "../../AccountIdentity";

export default function MessageBox({ commentId, time, message, author, by, issue, role, showHistory = true }) {

    const deleteComment = useMyStore((store) => store.deleteComment);
    const [dropdownState, setDropdownState] = useState(false);
    if (issue?.resolutionStatus === "resolved") return <IssueResolution showHistory={showHistory} issue={issue} kind="comments" role={role}/>;
    return (
        <div className="flex items-start mb-1 no-drag">

            <div className="flex flex-col w-full leading-1.5 ml-1">
                <div className="flex items-left space-x-2 text-xs">
                    <AccountIdentity author={author} fallbackName={by} />
                    <span className="font-normal text-gray-500">{time}</span>
                </div>
                <div className="relative text-sm font-normal bg-white rounded p-2">
                    <div>{message}</div>
                    {issue && <IssueResolution showHistory={showHistory} issue={issue} kind="comments" role={role}/>}
                    <div className="absolute top-0 right-0">
                        <button
                            onClick={() => { setDropdownState(!dropdownState) }}
                            id="dropdownMenuIconButton" data-dropdown-toggle="dropdownDots" data-dropdown-placement="bottom-start"
                            className="inline-flex items-center p-2 text-sm bg-white outline-1 font-medium text-center rounded-lg dark:text-white focus:ring-gray-50 dark:bg-gray-900 dark:hover:bg-gray-800 dark:focus:ring-gray-600" type="button">
                            <svg className="w-1 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
                                <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                            </svg>
                        </button>
                        {
                            dropdownState && (
                                <div id="dropdownDots" className={`fixed right-0 z-30 bg-white divide-y divide-gray-100 rounded-lg shadow w-min dark:bg-gray-700 dark:divide-gray-600`}>
                                    <ul className="text-sm text-gray-600" aria-labelledby="dropdownMenuIconButton">
                                        <li>
                                            <button className="block px-4 py-2 w-full rounded-t-lg hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Reply</button>
                                        </li>
                                        <li>
                                            <button className="block px-4 py-2 w-full hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Forward</button>
                                        </li>
                                        <li>
                                            <button className="block px-4 py-2 w-full hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Copy</button>
                                        </li>
                                        <li>
                                            <button className="block px-4 py-2 w-full hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Report</button>
                                        </li>
                                        <li>
                                            <button onClick={() => { deleteComment(commentId); }} className="block px-4 py-2 w-full rounded-b-lg hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Delete</button>
                                        </li>
                                    </ul>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
